import ProfileApartmentOneCreate from './ProfileApartmentOneCreate.vue';

export { ProfileApartmentOneCreate };
export default ProfileApartmentOneCreate;
